import { ERefundMotiveId } from 'v2/interfaces/requestManagement/refund';
import * as Yup from 'yup';

const RefundBuyerRequestSchema = Yup.object().shape({
  motive: Yup.string().required('Selecione um motivo'),
  detail: Yup.string().when('motive', {
    is: (v: string) => v === ERefundMotiveId.OTHER_REASON,
    then: Yup.string().required('Insira os detalhes do reembolso').min(5)
  })
});

export { RefundBuyerRequestSchema };
